import { iaRa } from 'lib/helpers/utility';

import { amountToCents } from 'components/practice/BeyondBilling/Claims/CMS1500/lib/amountToCents';

export const checkDuplicatePayment = (procedures, payments) => {
  const allEras = iaRa(payments?.era);
  const allEobs = iaRa(payments?.eob);
  const allPayments = [...allEras, ...allEobs];

  const totalPaid = iaRa(procedures)?.reduce((acc, procedure) => {
    return acc + amountToCents(procedure?.paid);
  }, 0);

  const exists = allPayments?.some((payment) => {
    return payment?.amount_paid === totalPaid;
  });

  return exists;
};
